module.exports = __webpack_public_path__ + "img/banner2.fba133a9.jpg";